import { useTenant } from '@providers/Tenant';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { SideNavManage } from 'src/components/SideNav/SideNavManage';
import { useConfiguration } from 'src/providers/Configuration';

export function ManageNav({
  page,
}: Readonly<{ page: 'product-overview' | 'kits' | 'sales-bom' | 'parts-categories' }>) {
  const { productId } = useParams<{ productId: string }>(); // we want the encoded productId here as we just pass it on to create links, so we don't have to decode it using useDecodedParams
  const { t } = useTranslation('manageProduct');
  const { name, status, isUpdating, isUpdatingPartsCategories, isUpdatingSalesBOM, isUpdatingKits } =
    useConfiguration();
  const params = new URLSearchParams(window.location.search);
  const configurationPID = params.get('configurationPID') ?? '';
  const { enabledFeatures } = useTenant();

  const uiStatus = isUpdating ? 'UPDATING' : status;

  const links = [
    {
      href: `/manage-product/${productId}?configurationPID=${configurationPID}`,
      name: 'product-overview',
      text: t('productOverview.title'),
      disabled: isUpdating,
    },
    {
      href: `/manage-product/${productId}/parts-categories?configurationPID=${configurationPID}`,
      name: 'parts-categories',
      text: t('partsCategories.title'),
      disabled: isUpdating && !isUpdatingPartsCategories,
    },
    {
      href: `/manage-product/${productId}/sales-bom?configurationPID=${configurationPID}`,
      name: 'sales-bom',
      text: t('salesBOM.title'),
      disabled: isUpdating && !isUpdatingSalesBOM,
    },
  ];

  if (enabledFeatures.includes('kits')) {
    links.push({
      href: `/manage-product/${productId}/kits?configurationPID=${configurationPID}`,
      name: 'kits',
      text: t('kits.title'),
      disabled: isUpdating && !isUpdatingKits,
    });
  }

  return <SideNavManage title={name} status={uiStatus} selected={page} links={links} />;
}
